import { format as dateFnsFormat } from "date-fns";
import { sv } from "date-fns/locale";

export const format = (...parameters: Parameters<typeof dateFnsFormat>) => {
  const options = { locale: sv, ...parameters[2] };
  return dateFnsFormat(parameters[0], parameters[1], options);
};
